import React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import RankingsRow from './RankingsRow';
import OneA_Button_Img from '../images/1A_Button.png'
import TwoA_Button_Img from '../images/2A_Button.png'
import ThreeA_Button_Img from '../images/3A_Button.png'
import FourA_Button_Img from '../images/4A_Button.png'
import B_Button_Img from '../images/B_Button.png'
import Small_Girls_Button_Img from '../images/Small_Girls_Button.png'
import All_State_Button_Img from '../images/all_state_Button.png'
import AdditionalLinksBackground from '../images/Additional_Links_Background.png'

const RankingsTable = () => {
    const { genderId, classificationId, weightId } = useParams();
    const [loaded, setLoaded] = useState(false);
    const [rows, setRows] = useState([]);

    const rankingsReference = {
        b_4ab_106: '785673503',
        b_4ab_113: '1583372521',
        b_4ab_120: '983658284',
        b_4ab_126: '1922767654',
        b_4ab_132: '1895536072',
        b_4ab_138: '95601916',
        b_4ab_144: '1424111836',
        b_4ab_150: '1445910306',
        b_4ab_157: '1612702814',
        b_4ab_165: '1498132965',
        b_4ab_175: '2039816382',
        b_4ab_190: '875317452',
        b_4ab_215: '845244158',
        b_4ab_285: '1073348999',

        b_3ab_106: '2020280022',
        b_3ab_113: '1935036400',
        b_3ab_120: '1959845145',
        b_3ab_126: '1021886848',
        b_3ab_132: '391962583',
        b_3ab_138: '1737312637',
        b_3ab_144: '1128046638',
        b_3ab_150: '735166526',
        b_3ab_157: '1429537593',
        b_3ab_165: '1362012135',
        b_3ab_175: '1515755200',
        b_3ab_190: '450259079',
        b_3ab_215: '1411121462',
        b_3ab_285: '1765233657',

        b_2ab_106: '26881779',
        b_2ab_113: '629139048',
        b_2ab_120: '1175585134',
        b_2ab_126: '1958335413',
        b_2ab_132: '1010917230',
        b_2ab_138: '1132958454',
        b_2ab_144: '694004019',
        b_2ab_150: '995703891',
        b_2ab_157: '1193784096',
        b_2ab_165: '1361619150',
        b_2ab_175: '2065271090',
        b_2ab_190: '563734749',
        b_2ab_215: '588143284',
        b_2ab_285: '769409052',

        b_1ab_106: '1109988425',
        b_1ab_113: '284752803',
        b_1ab_120: '1229211301',
        b_1ab_126: '696292097',
        b_1ab_132: '1962810829',
        b_1ab_138: '1155245576',
        b_1ab_144: '714951278',
        b_1ab_150: '386697789',
        b_1ab_157: '1085792106',
        b_1ab_165: '75970702',
        b_1ab_175: '1054033304',
        b_1ab_190: '1058050100',
        b_1ab_215: '541362020',
        b_1ab_285: '1198717794',

        b_bb_106: '881481409',
        b_bb_113: '325430923',
        b_bb_120: '2119061337',
        b_bb_126: '979684973',
        b_bb_132: '1079055866',
        b_bb_138: '1888219622',
        b_bb_144: '1289558446',
        b_bb_150: '417960357',
        b_bb_157: '454415900',
        b_bb_165: '1750668753',
        b_bb_175: '297113832',
        b_bb_190: '1339708808',
        b_bb_215: '1990848485',
        b_bb_285: '79198589',

        g_4ag_100: '0',
        g_4ag_105: '915398947',
        g_4ag_110: '1809426812',
        g_4ag_115: '78454200',
        g_4ag_120: '382123822',
        g_4ag_125: '1937979772',
        g_4ag_130: '541893401',
        g_4ag_135: '1982425736',
        g_4ag_140: '2044503601',
        g_4ag_145: '925054543',
        g_4ag_155: '228357044',
        g_4ag_170: '1696083700',
        g_4ag_190: '2096322365',
        g_4ag_235: '688775059',

        g_3ag_100: '1847410441',
        g_3ag_105: '2008204164',
        g_3ag_110: '452030109',
        g_3ag_115: '1207063150',
        g_3ag_120: '1599820552',
        g_3ag_125: '483932039',
        g_3ag_130: '423300799',
        g_3ag_135: '1624980877',
        g_3ag_140: '1736396690',
        g_3ag_145: '1232044251',
        g_3ag_155: '409240995',
        g_3ag_170: '1216612303',
        g_3ag_190: '1262140008',
        g_3ag_235: '1035923687',

        g_2ag_100: '1543950636',
        g_2ag_105: '354666287',
        g_2ag_110: '1426180034',
        g_2ag_115: '1207385111',
        g_2ag_120: '378279385',
        g_2ag_125: '1909226695',
        g_2ag_130: '1732521665',
        g_2ag_135: '1367240698',
        g_2ag_140: '77222630',
        g_2ag_145: '1594233879',
        g_2ag_155: '259985084',
        g_2ag_170: '1460444529',
        g_2ag_190: '1417490267',
        g_2ag_235: '1361618893',

        g_1a1b2bg_100: '1679425758',
        g_1a1b2bg_105: '108348691',
        g_1a1b2bg_110: '913591723',
        g_1a1b2bg_115: '1276564034',
        g_1a1b2bg_120: '1830615014',
        g_1a1b2bg_125: '286081645',
        g_1a1b2bg_130: '1441050106',
        g_1a1b2bg_135: '889061244',
        g_1a1b2bg_140: '1847617239',
        g_1a1b2bg_145: '786893356',
        g_1a1b2bg_155: '303702383',
        g_1a1b2bg_170: '2092067116',
        g_1a1b2bg_190: '580814573',
        g_1a1b2bg_235: '409033691',

        b_as_106: '0',
        b_as_113: '932211766',
        b_as_120: '821722186',
        b_as_126: '1444649224',
        b_as_132: '1501464064',
        b_as_138: '540547729',
        b_as_144: '853424320',
        b_as_150: '285209284',
        b_as_157: '2123268016',
        b_as_165: '787876832',
        b_as_175: '121532487',
        b_as_190: '1429813545',
        b_as_215: '536875957',
        b_as_285: '235148451',

        g_as_100: '1332963829',
        g_as_105: '2111295168',
        g_as_110: '1349960519',
        g_as_115: '292145947',
        g_as_120: '382908967',
        g_as_125: '1597011653',
        g_as_130: '1279212743',
        g_as_135: '956557403',
        g_as_140: '1424074927',
        g_as_145: '138676587',
        g_as_155: '502664451',
        g_as_170: '1747500322',
        g_as_190: '2042439873',
        g_as_235: '1469453921'
    };

    const gidKey = genderId + '_' + classificationId + '_' + weightId;
    const GID = rankingsReference[gidKey];

    const GIRLS_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ4wV0z4WP252-CO2yBblNeU9Vl3T254kbnljAQtU8GIW6PW8APJdNXBywIjyyi-zETXPHSo3PZbqo9/';
    const BOYS_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTq2fnBK7Ej2wTitwnXwdqSVGqBb0wxxdUq3BujCGuMNmWd6bjb99JPcGuR7oARrx9lLblVaK48QwSC/';
    const ALL_STATE_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS70Z3F0mu6MVkrHoxT4FwGqexx7JA23uLfCvJpy9nvN_O-T5jcqZmzDiaQe4fzTf7SluRE88I-vzYo/'


    function getSheetUrl(genderId, classificationId, GID) {
        if (genderId === 'b' && classificationId !== "as") {
            return BOYS_SHEET_URL + 'pub?gid=' + GID + '&single=true&output=csv'
        } else if (genderId === 'g' && classificationId !== "as") {
            return GIRLS_SHEET_URL + 'pub?gid=' + GID + '&single=true&output=csv'
        } return ALL_STATE_SHEET_URL + 'pub?gid=' + GID + '&single=true&output=csv'
    }

    const SHEET_URL = getSheetUrl(genderId, classificationId, GID) + `&timestamp=${Date.now()}`;
    // const SHEET_URL = getSheetUrl(genderId, classificationId, GID)

    useEffect(() => {
        fetch(SHEET_URL)
            .then(response => {
                if (!response.ok) throw new Error('Failed to fetch data');
                return response.text();
            })
            .then(csv => {
                setRows(csv.split('\n').map(row => row.split(',')));
                setLoaded(true);
            })
            .catch(error => console.error('Error:', error));
    }, [loaded, rows]);

    const headerImageSet = () => {
        let headerImage = null;
        // if (genderSet.length < 4) {
        //   return headerImage;
        // }
        if (classificationId.charAt(0) == "4") {
          headerImage = <img class="classificationImages" src={FourA_Button_Img} alt="4A Rankings Button" />
        }
        if (classificationId.charAt(0) == "3") {
          headerImage = <img class="classificationImages" src={ThreeA_Button_Img} alt="3A Rankings Button" />
        }
        if (classificationId.charAt(0) == "2") {
          headerImage = <img class="classificationImages" src={TwoA_Button_Img} alt="2A Rankings Button" />
        }
        if (classificationId.charAt(0) == "1") {
          headerImage = <img class="classificationImages" src={OneA_Button_Img} alt="1A Rankings Button" />
        }
        if (classificationId.charAt(0) == "b") {
          headerImage = <img class="classificationImages" src={B_Button_Img} alt="B Rankings Button" />
        }
        if (classificationId.length > 4) {
          headerImage = <img class="classificationImages" src={Small_Girls_Button_Img} alt="Small Girls Rankings Button" />
        }
        if (classificationId === "as") {
            headerImage = <img class="classificationImages" src={All_State_Button_Img} alt="All State Rankings Button" />
        }
          return headerImage;
      }
    


    return (
        <div id='rankings_table_container' style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
            <div id='rankings_header_div'>
                <h1 class="rankings_img_tag">
                    {headerImageSet()}
                </h1>
            </div>
            {!loaded ?
                <h1>LOADING...</h1>
                :
                <table cellSpacing="0" cellPadding="0" class="rankings_table">
                    <tbody>
                        {loaded && rows.slice(0, 17).map((row, i) => {
                            return (
                                <RankingsRow rowKey={i} row={row} />
                            )
                        })}
                    </tbody>

                </table>
            }
            <h2 className="text-center contact_text">Contact us at <br/> washingtonwrestlingrankings@gmail.com</h2>
        </div>
    )
};

export default RankingsTable;